import React from 'react';
import Spreadsheet from 'react-spreadsheet';




const Table = ({ data }) => {
    const validData = Array.isArray(data) ? data : [];
  return (
    <div>
      {/* <Spreadsheet data={validData} /> */}
    </div>
  );
};


export default Table;
